import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({ activeTab }) => {
  const getMessage = () => {
    switch (activeTab) {
      case "serviceRequests":
        return "No service requests have been submitted yet.";
      case "contractors":
        return "No contractors have signed up yet.";
      case "contact":
        return "No contact messages have been received yet.";
      case "customers":
        return "No customers have been added yet.";
      case "dailyJobs":
        return "No jobs have been scheduled yet.";
      default:
        return "No data available.";
    }
  };

  return (
    <div className="card">
      <div className="p-12 text-center">
        <div className="w-16 h-16 bg-secondary-100 rounded-full mx-auto mb-4 flex items-center justify-center">
          <Inbox className="w-8 h-8 text-secondary-400" />
        </div>
        <h3 className="text-lg font-semibold text-secondary-900 mb-2">No Data Found</h3>
        <p className="text-secondary-600">
          {getMessage()}
        </p>
      </div>
    </div>
  );
};

export default EmptyState;